export default __webpack_public_path__ + "static/media/SurveyTestCards.542baa0e.png";